'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'unit', 'UnitService', 'StatusService',
    function ($scope, $modalInstance, unit, UnitService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.unit = angular.copy(unit);

            if (unit == null || angular.equals({}, unit) || unit.id == null) {
                $scope.title = "Создание новой единицы измерения";
            } else {
                $scope.title = 'Редактирование единицы измерения "' + $scope.unit.name + '"';
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.unit.status) {
                    $scope.unit.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.unit);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                UnitService.api.isUniqueName({name: name, id: $scope.unit.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else $scope.uniqueLogin = true;
        }

        // endregion

    }];